import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    logoEmpresa: "",
    condiciones: "",
    nombreEmpresa: "",
    emailEmpresa: "",
    direccionEmpresa: "",
    telefonoEmpresa: "",
    totalApagar: 0,
    numeroFactura: "",
    iva:21,
    irpf:0,
    articulos: [
      {
        precio: 0,
        cantidad: 1,
        titulo: "",
        descripcion: "",
      },
    ],
    reglaNumeroFactura: [
      (v) => !!v || "Este campo es obligatorio",
      (v) => v.length <= 10 || "Este campo deberíoa de tener menos de 10",
    ],
    textRules: [
      (v) => !!v || "Este campo es obligatorio",
    ],
    numberRules: [
      (v) => !!v || "Este campo es obligatorio",
      (v) => v >= 1 || "Este campo debería de ser mayor o igual a 1",
    ],
    requiredRules:[
      (v) => !!v || "Este campo es obligatorio",
    ]
  },
  mutations: {
    setTotalPagar(state, payload) {
      state.totalApagar = payload;
    },
    cargarLogoEmpresa(state, payload) {
      state.logoEmpresa = payload;
    },
    setTerminosCondiciones(state, payload) {
      state.condiciones = payload;
    },
    setNombreEmpresa(state, payload) {
      state.nombreEmpresa = payload;
    },
    setEmailEmpresa(state, payload) {
      state.emailEmpresa = payload;
    },
    setDireccionEmpresa(state, payload) {
      state.direccionEmpresa = payload;
    },
    setTelefonoEmpresa(state, payload) {
      state.telefonoEmpresa = payload;
    },
    //cliente
    setNombreCliente(state, payload) {
      state.nombreCliente = payload;
    },
    setEmailCliente(state, payload) {
      state.emailCliente = payload;
    },
    setDireccionCliente(state, payload) {
      state.direccionCliente = payload;
    },
    setTelefonoCliente(state, payload) {
      state.telefonoCliente = payload;
    },
    setNumeroFactura(state, payload) {
      state.numeroFactura = payload;
    },
    setIva(state, payload) {
      state.iva = payload;
    },
    setIrpf(state, payload) {
      state.irpf = payload;
    },
  },
  actions: {
    setLogoEmpresa({ commit }, payload) {
      console.log(payload);
      commit("cargarLogoEmpresa", payload);
    },
    cargarTerminoCondiciones({ commit }, payload) {
      //console.log("cargarTerminoCondiciones:" + payload);
      commit("setTerminosCondiciones", payload);
    },
    cargarNombreEmpresa({ commit }, payload) {
      console.log("cargarNombreEmpresa:" + payload);

      commit("setNombreEmpresa", payload);
    },

    cargarEmailEmpresa({ commit }, payload) {
      commit("setEmailEmpresa", payload);
    },
    cargarDireccionEmpresa({ commit }, payload) {
      commit("setDireccionEmpresa", payload);
    },
    cargarTelefonoEmpresa({ commit }, payload) {
      commit("setTelefonoEmpresa", payload);
    },
    ///Cliente
    cargarNombreCliente({ commit }, payload) {
      console.log("cargarNombreEmpresa:" + payload);

      commit("setNombreCliente", payload);
    },

    cargarEmailCliente({ commit }, payload) {
      commit("setEmailCliente", payload);
    },
    cargarDireccionCliente({ commit }, payload) {
      commit("setDireccionCliente", payload);
    },
    cargarTelefonoCliente({ commit }, payload) {
      commit("setTelefonoCliente", payload);
    },
    cargarTotalPagar({ commit }, payload) {
      console.log("El total a pagar es:" +payload )
      commit("setTotalPagar", payload);
    },
    cargarNumeroFactura({ commit }, payload) {
      commit("setNumeroFactura", payload);
    },
    cargarIva({ commit }, payload) {
      commit("setIva", payload);
    },
    cargarIrpf({ commit }, payload) {
      commit("setIrpf", payload);
    },
  },
  modules: {},
});
